import { render, staticRenderFns } from "./VircosDocumentPrint.vue?vue&type=template&id=34aa8500&scoped=true&"
import script from "./VircosDocumentPrint.vue?vue&type=script&lang=js&"
export * from "./VircosDocumentPrint.vue?vue&type=script&lang=js&"
import style0 from "./VircosDocumentPrint.vue?vue&type=style&index=0&id=34aa8500&lang=scss&scoped=true&"
import style1 from "./VircosDocumentPrint.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34aa8500",
  null
  
)

export default component.exports